import { assertEvent, assign } from 'xstate5';

import { addModificationToActiveModificationsList, resolveIngredientIdForAdd } from '../../helpers';
import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Handles the addition of a modification to the list of active modifications
 * within the customization context.
 */
export const addModification: CustomizationMachineAction = assign((args) => {
  const { context, event } = args;

  assertEvent(event, [
    'customization.add-modification',
    'customization.dressing.increase-portions',
  ]);

  const { allModificationsMap, modifications, extrasModificationsMap, modificationLimits } =
    context;

  if (!allModificationsMap || !modifications) {
    return {};
  }

  const { active } = modifications;

  const resolvedIngredientId = resolveIngredientIdForAdd({
    ingredientId: event.ingredientId,
    allModificationsMap,
    extrasModificationsMap,
    modificationLimits,
    activeModifications: active,
  });

  const updatedActives = addModificationToActiveModificationsList(
    resolvedIngredientId,
    active,
    allModificationsMap,
  );

  return { modifications: { ...modifications, active: updatedActives } };
});
